import { useEffect, useState } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { GetRides } from "../../Services";
import ExportTable from "../../components/exportTable";

const AllRides = () => {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchRides = async () => {
      setLoading(true);
      try {
        const data = await GetRides.fetchRides();
        setRides(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching rides:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRides();
  }, []);


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Filter rides based on search
  const filteredRides = rides.filter(
    (ride) =>
      ride.user.phone_number.includes(search) ||
      ride.id.toString().includes(search)
  );

  // Columns for export
  const columns = [
    { header: "Ride ID", accessor: "id" },
    { header: "User Phone", accessor: "userPhone" },
    { header: "Pickup Date", accessor: "createdAt" },
    { header: "Drop Time", accessor: "updatedAt" },
    { header: "Pickup Point", accessor: "currentLocationName" },
    { header: "Drop Point", accessor: "destinationLocationName" },
    { header: "Distance", accessor: "distance" },
    { header: "Status", accessor: "status" },
  ];

  // Data for export
  const exportData = filteredRides.map((ride) => ({
    id: ride.id,
    userPhone: ride.user.phone_number,
    createdAt: ride.createdAt,
    updatedAt: ride.updatedAt,
    currentLocationName: ride.currentLocationName,
    destinationLocationName: ride.destinationLocationName,
    distance: ride.distance,
    status: ride.status,
  }));

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">All Rides</h2>
        </div>

        <div className="card">
          <div className="card-header">
            <button type="button" className="btn btn-outline-secondary ml-2">
              <FaChevronLeft className="mr-1" /> Back
            </button>
          </div>

          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <ExportTable data={exportData} columns={columns} />
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                style={{ width: "300px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="mt-4">
              {loading ? (
                <div>
                  <p>Loading ride history...</p>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : filteredRides.length === 0 ? (
                <div>
                  <p>No rides found.</p>
                </div>
              ) : (
                <table className="table table-bordered w-full">
                  <thead>
                    <tr>
                      <th>Ride ID</th>
                      <th>User Phone</th>
                      <th>Pickup Date</th>
                      <th>Drop Time</th>
                      <th>Pickup Point</th>
                      <th>Drop Point</th>
                      <th>Distance</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRides.map((ride) => (
                      <tr key={ride.id}>
                        <td>{ride.id}</td>
                        <td>{ride.user.phone_number}</td>
                        <td>{ride.createdAt}</td>
                        <td>{ride.updatedAt}</td>
                        <td>{ride.currentLocationName}</td>
                        <td>{ride.destinationLocationName}</td>
                        <td>{ride.distance}</td>
                        <td>
                          <span
                            style={{
                              color:
                                ride.status === "PENDING"
                                  ? "orange"
                                  : ride.status === "COMPLETE"
                                  ? "green"
                                  : ride.status === "CANCELED"
                                  ? "red"
                                  : "gray",
                              backgroundColor:
                                ride.status === "PENDING"
                                  ? "#fff3cd"
                                  : ride.status === "COMPLETE"
                                  ? "#d4edda"
                                  : ride.status === "CANCELED"
                                  ? "#f8d7da"
                                  : "#e9ecef",
                              padding: "2px 5px",
                              borderRadius: "4px",
                            }}
                          >
                            {ride.status.charAt(0).toUpperCase() +
                              ride.status.slice(1).toLowerCase()}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            <div className="card-footer clearfix">
              <ul className="pagination pagination-sm m-0 float-right">
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage > 1) handlePageChange(currentPage - 1);
                    }}
                  >
                    &laquo;
                  </a>
                </li>
                {[...Array(totalPages).keys()].map((page) => (
                  <li
                    className={`page-item ${
                      currentPage === page + 1 ? "active" : ""
                    }`}
                    key={page + 1}
                  >
                    <a
                      className="page-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(page + 1);
                      }}
                    >
                      {page + 1}
                    </a>
                  </li>
                ))}
                <li className="page-item">
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentPage < totalPages)
                        handlePageChange(currentPage + 1);
                    }}
                  >
                    &raquo;
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllRides;
